"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAbortError = exports.isNetworkError = void 0;
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
function isNetworkError(error, metricsPrefix) {
    if (error instanceof TypeError) {
        const msg = error.message.toLocaleLowerCase();
        const isForOneOfTheBrowsers = msg.startsWith("failed to fetch") || // chrome, edge
            msg.startsWith("network error") || // firefox
            msg.startsWith("networkerror") || // firefox
            msg.startsWith("load failed"); // safari
        void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.network_error_typeerror`, 1, {
            name: error.name.toLocaleLowerCase(),
            msg: msg.substring(0, 20).toLocaleLowerCase(),
        });
        return isForOneOfTheBrowsers;
    }
    if (error instanceof DOMException) {
        void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.network_error_domexception`, 1, {
            name: error.name.toLocaleLowerCase(),
            msg: error.message.substring(0, 20).toLocaleLowerCase(),
        });
        return error.name === "NetworkError";
    }
    return false;
}
exports.isNetworkError = isNetworkError;
function isAbortError(error) {
    if (!(error instanceof DOMException)) {
        return false;
    }
    const msg = error.message.toLocaleLowerCase();
    return (error.name === "AbortError" ||
        msg.startsWith("the operation was aborted") ||
        msg.startsWith("the user aborted a request"));
}
exports.isAbortError = isAbortError;
//# sourceMappingURL=error.js.map